function RetreatProgram() {
    return (
        <div className='program_page'>
            <h1 className="page_title">Программа ретрита</h1>
            {/*<p className='page_addition'>*Предоставляем трансфер из Лондона</p>*/}
            {/*<div className="date_info">*/}
            {/*    <p>Заезд 17:00</p>*/}
            {/*    <p>Выезд 15:00</p>*/}
            {/*</div>*/}

            <div className="program_section">
                <h2>Воскресенье</h2>
                <ul>
                    <li><span>10:00</span> Сбор гостей, приветственный чай</li>
                    <li><span>10:20</span> Дыхательная практика и настройка у озера  </li>
                    <li><span>10:40</span> Пилатес: мягкая практика для всего тела, осанка и дыхание</li>
                    <li><span>11:45</span> Женские аффирмации и расслабление на берегу</li>
                    <li><span>12:00</span> Веганский фуршет</li>
                    <li><span>12:45</span> Дыхание, заземление и намерение на вторую практику</li>
                    <li><span>13:00</span> Пилатес с оборудованием: глубокая проработка, женская энергия, пластичность</li>
                    <li><span>14:15</span> Индивидуальное стояние на гвоздях</li>
                    <li><span>15:30</span> Сауна и погружение в частное озеро</li>
                    <li><span>18:30</span> Завершение ретрита, тёплые прощания</li>
                </ul>

                {/*<h2>Суббота</h2>*/}
                {/*<ul>*/}
                {/*    <li><span>08:00-08:30</span> Спортивная ходьба по лесным тропинкам (аффирмация в лесу)</li>*/}
                {/*    <li><span>08:30-10:00</span> Пилатес с роллами</li>*/}
                {/*    <li><span>10:00-11:30</span> Завтрак</li>*/}
                {/*    <li><span>11:30-12:00</span> Дыхательные практики</li>*/}
                {/*    <li><span>12:00-12:30</span> Свободное время</li>*/}
                {/*    <li><span>12:30-14:00</span> Пилатес с мячами "Женское здоровье"</li>*/}
                {/*    <li><span>14:00-15:00</span> Обед</li>*/}
                {/*    <li><span>15:00-16:00</span> Свободное время</li>*/}
                {/*    <li><span>16:00-17:00</span> Сессия гвоздестояния</li>*/}
                {/*    <li><span>17:00-18:00</span> Снятие напряжения вокальными упражнениями</li>*/}
                {/*    <li><span>18:00-19:00</span> Стретчинг "Открытие женственности"</li>*/}
                {/*    <li><span>19:00-20:00</span> Ужин</li>*/}
                {/*    <li><span>20:00-21:00</span> Свободное время</li>*/}
                {/*    <li><span>21:00</span> Освобождение от эмоций в стиле AfroJazz</li>*/}
                {/*    <li>Перед сном погружение в джакузи с розовыми маслами и лепестками роз</li>*/}
                {/*</ul>*/}

                {/*<h2>Воскресенье</h2>*/}
                {/*<ul>*/}
                {/*    <li><span>08:00-08:30</span> Медитативная аффирмация в лесу</li>*/}
                {/*    <li><span>08:30-10:00</span> Пилатес с массажными мячами</li>*/}
                {/*    <li><span>10:00-11:00</span> Завтрак</li>*/}
                {/*    <li><span>11:00-12:00</span> Пилатес с рингами</li>*/}
                {/*    <li><span>12:00-13:00</span> Обед</li>*/}
                {/*    <li><span>13:00-15:00</span> Свободное время</li>*/}
                {/*    <li><span>15:00</span> Выезд</li>*/}
                {/*</ul>*/}
            </div>
        </div>
    );
}

export default RetreatProgram;